import englishLanguage from "./languages/englishLanguage"
import polishLanguage from "./languages/polishLanguage"
import swedishLanguage from "./languages/swedishLanguage"
import LanguageHandler, { Translations } from "@payair/e-com-common-sdk/core/LanguageHandler"
import { getValuesFromLocale } from "@payair/e-com-common-sdk/core/Helpers"
import { LocaleData } from "@payair/e-com-common-sdk/models/LocaleData"

/**
 * Keys format must base on ISO format for language (ISO 639-1).
 */
export const translations: Translations = {
  en: englishLanguage,
  pl: polishLanguage,
  sv: swedishLanguage,
}

export const DEFAULT_LOCALE = "en_GB"

export const getSupportedLocaleData = (locale: string | undefined): LocaleData => {
  if (!locale) {
    return getDefaultLocaleData(locale, false)
  }

  const localeData = getValuesFromLocale(locale)
  if (!localeData) {
    return getDefaultLocaleData(locale, true)
  }

  const isLangSupported = Object.keys(translations).includes(localeData.lang)
  if (!isLangSupported) {
    return getDefaultLocaleData(locale, true)
  }

  return localeData
}

export const getLocale = (localeData: LocaleData) => {
  return `${localeData.lang}_${localeData.countryCode}`
}

export const getLanguageHandler = (lang: string) => {
  const languageHandler = new LanguageHandler(translations)
  languageHandler.init(lang)
  return languageHandler
}

export const getDefaultLocaleData = (notValidLocale: string | undefined, showWarn: boolean) => {
  if (showWarn) {
    console.warn(
      `${notValidLocale} locale is not valid or supported. ` +
        `Supported langs ${Object.keys(translations).join(", ")}. ` +
        `Switching to default locale: ${DEFAULT_LOCALE}.`
    )
  }

  const defaultLocaleData = getValuesFromLocale(DEFAULT_LOCALE)
  if (!defaultLocaleData) {
    throw new Error("Locale error")
  }
  return defaultLocaleData
}
